module.exports = __webpack_public_path__ + "media/images/arrow-w@3x-32214053a337a59e7e9e1a9698753dcd.png";